/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchUserAutoWithdrawalSettingsResponseItem } from './search-user-auto-withdrawal-settings-response-item';


export interface SearchUserAutoWithdrawalSettingsResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchUserAutoWithdrawalSettingsResponseItem> | null;
}

